module.exports = __webpack_public_path__ + "static/mountainpass-logo-1200x1200-cebe29f2299cbe008bee38f868a1868d.jpg";